/* Phase 3.1 / Phase 3.2 patch — Pop-out chat window.
 *
 * Standalone ChatPanel host that talks to the same BroadcastChannel
 * (stackroom-chat-{room_id}) as the room window so the two stay in sync.
 *
 * Note on the auth gate: `useAuth()` exposes `user` only — `null` means
 * "checking", `false` means anonymous, otherwise the user object. We do NOT
 * read a `ready` flag (that field does not exist), since the previous
 * implementation got that wrong and the pop-out rendered nothing.
 *
 * Live updates from OTHER participants are picked up because the main room
 * window now rebroadcasts incoming LiveKit chat data packets through the
 * BroadcastChannel (see ChatPanel.jsx -> ThreadView.registerHandler).
 */
import { useParams } from "react-router-dom";
import { useAuth } from "../lib/auth-context";
import ChatPanel from "../components/ChatPanel";

export default function ChatPopout() {
  const { roomId } = useParams();
  const { user } = useAuth();

  // null = still loading auth. false = anonymous (guests handled via cookies).
  if (user === null) {
    return (
      <div className="h-screen w-screen grid place-items-center bg-[#05050a] text-white/60 text-sm">
        Loading chat…
      </div>
    );
  }

  // For guest popouts we don't know the identity until the room window opens
  // the DM — but the panel itself loads threads + history via cookie-auth,
  // which works for both user sessions and guest sessions.
  const myIdentity = user?.user_id || "";
  const canModerate = !!user?.discord_id;

  return (
    <div className="h-screen w-screen bg-[#05050a] grid grid-rows-[auto_1fr]" data-testid="chat-popout-root">
      <header className="flex items-center gap-2 px-3 py-2 border-b border-white/10 bg-[#08080c]">
        <span className="font-display text-sm font-bold tracking-tight">Full Spectrum Center · Chat</span>
        <span className="text-[10px] font-mono text-white/40 ml-1">room {roomId}</span>
        <button onClick={() => window.close()}
                className="ml-auto text-[10px] text-white/40 hover:text-white"
                data-testid="chat-popout-close">close</button>
      </header>
      <div className="overflow-hidden h-full">
        <ChatPanel
          roomId={roomId}
          myIdentity={myIdentity}
          canModerate={canModerate}
          registerHandler={() => () => {}}
          participants={[]}
          open
          onClose={() => window.close()}
        />
      </div>
    </div>
  );
}
